import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseInput } from './BaseInput';
export const TextInput = forwardRef((_a, ref) => {
    var { labelPosition = 'top', width = '100%' } = _a, props = __rest(_a, ["labelPosition", "width"]);
    return (_jsx(BaseInput, Object.assign({}, props, { labelPosition: labelPosition, ref: ref, type: "text", width: width })));
});
//# sourceMappingURL=TextInput.js.map